import {ChangeDetectionStrategy, Component} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {GrupperVisKomponent} from "../grupper-vis/grupper-vis";
import {GrupperListKomponent} from "../grupper-list/grupper-list";
import {MatIcon} from "@angular/material/icon";
import {gjørDersomIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {BrukerkontekstAdministrasjon} from "felles-ng2/tjenester/BrukerkontekstAdministrasjon";
import {NavigasjonDeaktivering} from "web-ng2/tjenester/NavigasjonDeaktivering";

const debug = initDebugger('GrupperHovedKomponent');

export type GrupperVisningsmodus = 'liste' | 'kort';

@Component({
    selector: 'grupper-hoved',
    templateUrl: 'grupper-hoved.html',
    styleUrl: 'grupper-hoved.scss',
    imports: [
        TranslateModule,
        MatButtonToggleGroup,
        MatButtonToggle,
        GrupperVisKomponent,
        GrupperListKomponent,
        MatIcon,
        ReactiveFormsModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GrupperHovedKomponent {
    static ajsSelector = 'grupperHoved';

    visningsmodusKontroll = new FormControl<GrupperVisningsmodus>('kort', {nonNullable: true});
    navigasjonDeaktivert = this.navigasjonDeaktivering.navigasjonDeaktivertSomSignal

    constructor(private kontekst: BrukerkontekstTilbyder, private kontekstAdministrasjon: BrukerkontekstAdministrasjon, private navigasjonDeaktivering: NavigasjonDeaktivering) {
        gjørDersomIkkeNil(this.kontekst.autentisertBruker().brukervalg.grupperVisningsmodus, modus => this.visningsmodusKontroll.setValue(modus));
        //lagre valgt visningsmodus i brukervalg
        this.visningsmodusKontroll.valueChanges.pipe(takeUntilDestroyed()).subscribe(modus => this.kontekstAdministrasjon.oppdaterBrukervalg({grupperVisningsmodus: modus}));
    }

}

